// import { hasProperty } from '@spa/util/helpers';

import axios from "axios";
import ETHValidator from "./ethereum_validator";

export default {
  isValidAddress(address, currency, network, addressFormat) {
    const notValidEthAddressBase = !ETHValidator.isValidAddress(address);
    if (notValidEthAddressBase) {
      return false;
    }

    const loopringValidatorURL = `https://api3.loopring.io/api/v3/account?owner=${address}`;

    return axios
      .get(loopringValidatorURL)
      .then(({ data }) => {
        if (Object.hasOwnProperty.call(data, "frozen")) {
          return !data.frozen;
        }

        return true;
      })
      .catch((error) => {
        console.error("Valid erc20 address, need to create a lrc contract");
        console.error(error);
        return true;
      });
  },
};
